import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token } from '../../../../Login/Auth';

import { SELECT_VAL_TYPE_INT } from '../../../Res/BaseInput';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { api_getUmpireList } from '../../../../../api/MyStat/apiUmpire';
import { TableListTitle, setTD, setTDLink, ListBox } from '../../../../../item/ItemTableList';
import { ReqUmpireList } from '../../../../../item/MyStat/ItemUmpire';
import { ACTIVATION_ENABLE, search_activation_attr, get_activation_string, get_activation_color } from '../../../../../item/MyStat/ItemMyStatBase';

export function UMPList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [searchItems, setSearchItems] = useState([])

    const [leagueList, setUmpireList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)

    // const [mReqUmpireList, setReqUmpireList] = useState({})

    const [list_obj, set_list_obj] = useState({})

    const [searchItem, set_searchItem] = useState()

    useEffect(() => {
        var searchItems = [
            [
                new SearchInput({
                    key: 'ump_name',
                    val: '',
                    defaultVal: '',
                    title: '以中文名稱搜尋',
                    col: 4
                }),
                new SearchSelect({
                    key: 'ump_activation',
                    val: ACTIVATION_ENABLE,
                    defaultVal: ACTIVATION_ENABLE,
                    valType: SELECT_VAL_TYPE_INT,
                    title: '狀態',
                    col: 4,
                    attr: search_activation_attr
                })
            ],
            // new SearchBrLine()
        ]
        setSearchItems(searchItems)
    }, [])

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqUmpireList = new ReqUmpireList({ start, limit })
            if (url === "") {
                toSearch({ searchItem: mReqUmpireList, page: url.page })
            } else {
                mReqUmpireList.fromJson(url)
                // console.log(mReqUmpireList)
                toSearch({ searchItem: mReqUmpireList, page: url.page })
            }
        }
    }, [id])

    useEffect(() => {
        var contents = []
        leagueList.forEach(item => {
            var content = []
            content.push(setTD({ content: item._id }))
            content.push(setTDLink({ link: 'UMP_Detail', content: item.ump_name + " " + moment(item.ump_DOB).format('YYYY'), key: 'UMPEdit', val: item }))
            content.push(setTD({ content: item.ump_name_eng }))
            content.push(setTD({ content: moment(item.logo_ump_date).format('YYYY-MM-DD') }))
            content.push(setTD({ content: get_activation_string(item.ump_activation), color: get_activation_color(item.ump_activation) }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('編號', 2),
                new TableListTitle('中文名稱', 3),
                new TableListTitle('英文姓名', 3),
                new TableListTitle('異動日期', 2),
                new TableListTitle('狀態', 2),
            ],
            contents
        }

        set_list_obj(lb)

    }, [leagueList])

    function toActionSearch(searchItems) {
        // console.log(searchItems)
        var mReqUmpireList = new ReqUmpireList({})
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    if (item.key === "ump_name") {
                        mReqUmpireList.ump_name = item.val
                    } else if (item.key === "ump_activation") {
                        mReqUmpireList.ump_activation = item.val
                    }
                })
            }
        })
        console.log(mReqUmpireList)
        setSearchItems(searchItems)
        toSearch({items: mReqUmpireList})
    }

    function toSearch({ searchItem, page = 1 }) {
        //console.log("toSearch")
        // console.log(items)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqUmpireList = new ReqUmpireList({ start, limit })
        if (searchItem !== undefined){
            mReqUmpireList.fromJson(searchItem)
            mReqUmpireList.start = start
            mReqUmpireList.limit = limit
        }
        // setReqUmpireList(mReqUmpireList)
        set_searchItem(mReqUmpireList)
        setVal2Token("url", mReqUmpireList, id)
        getUmpireList(mReqUmpireList)
    }

    function getUmpireList(mReqUmpireList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqUmpireList)
        api_getUmpireList({
            mReqUmpireList,
            success: (obj) => {
                // console.log(obj)
                setUmpireList(obj.list)
                setCount(obj.count)
                setEnableCount(obj.enableCount)
                setDisableCount(obj.disableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/UMP_Add");
    }

    var baseTitle = "主審列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"啟用"} count={enableCount} />
                    <DisableBadge text={"停用"} count={disableCount} />
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <Space />
            <ListBox row={6}lb={list_obj} srl={setUmpireList} count={count} page={page} sp={toSearch} searchItem={searchItem} />
        </>
    return (
        <>
            <BaseSearchBox action={toActionSearch} items={searchItems} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

